function NewlineText(props) {
  const text = props.text;
  const newText = text.split('\n').map(str => <div style={{ color: "black", fontSize: 13 }}>{str}</div>);

  return newText;
}

export default NewlineText;